import React from 'react';
import PropTypes from 'prop-types';

export const Signature = ({ width, height, ...props }) => (
  <svg
    data-icon='signature'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M14.075 11.725c1.217-.9 2.167-1.887 2.85-2.963.683-1.075 1.025-2.145 1.025-3.212 0-.533-.087-.925-.262-1.175A.826.826 0 0 0 16.974 4c-.783 0-1.475.662-2.075 1.987-.6 1.325-.9 2.821-.9 4.488 0 .233.004.454.012.662.009.209.03.405.063.588ZM3 21v-2h2v2H3Zm4 0v-2h2v2H7Zm4 0v-2h2v2h-2Zm4 0v-2h2v2h-2Zm4 0v-2h2v2h-2ZM3.4 17 2 15.6 3.6 14 2 12.4 3.4 11 5 12.6 6.6 11 8 12.4 6.4 14 8 15.6 6.6 17 5 15.4 3.4 17Zm12.05-1c-.5 0-.958-.096-1.375-.287-.417-.192-.775-.505-1.075-.938-.417.233-.846.442-1.287.625-.442.183-.896.367-1.363.55l-.7-1.875a17.878 17.878 0 0 0 2.575-1.15 9.567 9.567 0 0 1-.188-1.2c-.041-.433-.062-.9-.062-1.4 0-2.4.475-4.387 1.425-5.962C14.35 2.786 15.542 2 16.975 2c.867 0 1.575.32 2.125.962.55.642.825 1.538.825 2.688 0 1.433-.454 2.85-1.363 4.25-.908 1.4-2.17 2.658-3.787 3.775.117.117.237.204.362.262a.907.907 0 0 0 .388.088c.433 0 .937-.275 1.513-.825.575-.55 1.095-1.275 1.562-2.175l1.825.85a4.772 4.772 0 0 0-.275 1.025c-.067.4-.058.75.025 1.05.167-.083.363-.225.587-.425.226-.2.455-.45.688-.75L23.025 14a5.616 5.616 0 0 1-1.5 1.45c-.567.367-1.092.55-1.575.55-.35 0-.662-.104-.938-.313-.274-.208-.504-.529-.687-.962a5.59 5.59 0 0 1-1.425.95 3.519 3.519 0 0 1-1.45.325Z'
    />
  </svg>
);

Signature.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Signature.defaultProps = {
  width: 24,
  height: 24,
};
